<template>
	<v-hover>
		<div slot-scope="{ hover }" class="group" :class="{ edit: isEdit, 'allow-edit': allowEdit }" @click="clickGroup">
			<table style="width: 100%">
				<tr>
					<td class="text-xs-left">
						<div v-show="!isEdit">
							<h2 v-if="group != null">{{ group }}</h2>
							<h2 v-else class="ungrouped">[ ungrouped ]</h2>
						</div>
						<div v-show="isEdit" class="edit-box">
							<v-text-field ref="textfield" v-model="form.group" style="font-size:1.5em; font-weight: bold;" required full-width placeholder="New Group" background-color="#fff" :error-messages="groupErrors"></v-text-field>

							<table style="width: 100%">
								<tr>
									<td></td>
									<td style="width: 250px;" class="text-xs-right">
										<div v-show="isEdit">
											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<v-btn small v-on="on" @click.stop="cancelEdit">Cancel</v-btn>
												</template>
												<span>Cancel Edit</span>
											</v-tooltip>

											<v-tooltip bottom>
												<template v-slot:activator="{ on }">
													<v-btn small color="primary" v-on="on" @click.stop="saveChanges">Save</v-btn>
												</template>
												<span>Save Changes</span>
											</v-tooltip>
										</div>
									</td>
								</tr>
							</table>
						</div>
					</td>

					<v-expand-transition>
						<td v-if="hover" v-show="!isEdit && group != null && allowEdit" style="width: 150px;">
							<v-btn small class="error remove-btn" @click.stop="removeGroupClick">Remove</v-btn>
						</td>
					</v-expand-transition>
				</tr>
			</table>
		</div>
	</v-hover>
</template>

<script>
	import { validationMixin } from 'vuelidate';
	import { performanceReviewTemplateGroupName } from '@/validators';

	export default {
		props: {
			group: {
				type: String,
				required: false
			},
			existingGroups: {
				type: Array,
				required: true
			},
			allowEdit: {
				type: Boolean,
				required: false,
				default: true
			}
		},
		data() {
			return {
				isEdit: false,
				form: {
					group: this.group
				},
				original: null
			};
		},
		created() {
			this.original = this.group;
			if (this.isEmpty) {
				this.isEdit = true;

				this.$nextTick(() => {
					this.$refs.textfield.focus();
				});
			}
		},
		computed: {
			isEmpty() {
				return this.form.group != null && this.form.group.includes('New Group');
			},
			groupErrors() {
				const errors = [];
				if (!this.$v.form.group.$dirty) return errors;
				!this.$v.form.group.required && errors.push('Group Name is required.');
				return errors;
			}
		},
		mixins: [validationMixin],
		validations: {
			form: {
				group: { performanceReviewTemplateGroupName }
			}
		},
		methods: {
			clickGroup() {
				if (this.allowEdit) {
					this.isEdit = true;
					this.$nextTick(() => {
						this.$refs.textfield.focus();
					});
				}
			},
			removeGroupClick() {
				if (confirm('Are you sure you wish to remove this group?')) {
					this.$emit('onGroupRemoved', {
						original: this.original,
						updated: this.form.group
					});
				}
			},
			cancelEdit() {
				this.form.group = this.original;
				this.isEdit = false;

				if (this.isEmpty) {
					this.$emit('onGroupRemoved', {
						original: this.original,
						updated: this.form.group
					});
				}
			},
			saveChanges() {
				this.$v.form.$touch();

				if (this.$v.form.$invalid) {
					console.log('invalid form');
				} else {
					if (this.existingGroups.some(x => x === this.form.group)) {
						alert('This Group already exists');
					} else {
						this.isEdit = false;
						this.$emit('onGroupChanged', {
							original: this.original,
							updated: this.form.group
						});
						this.original = this.form.group;
					}
				}
			}
		}
	};
</script>

<style scoped>
	.group.allow-edit {
		cursor: pointer;
		padding: 5px;
		margin: 3px;
	}
	.group.allow-edit.edit {
		cursor: text;
		/* border-top: solid 1px blue;
				    border-bottom: solid 1px blue; */
		background-color: #e3f2fd;
	}
	.edit-box {
		margin-top: 10px;
	}
	.group:not(.edit).allow-edit:hover {
		background-color: rgba(0, 0, 0, 0.04);
	}
	.remove-btn {
		margin: 0;
		padding: 0;
	}
	.ungrouped {
		color: #9e9e9e;
	}
</style>
